import { useState } from 'react';

import BpkSelectableChip from '@skyscanner-internal/backpack-web/bpk-component-chip';
import BpkMobileScrollContainer from '@skyscanner-internal/backpack-web/bpk-component-mobile-scroll-container';
import BpkSectionHeader from '@skyscanner-internal/backpack-web/bpk-component-section-header';

import CardRail from '../CardRail';
import InventoryCard from '../InventoryCard';
import { useMBDContext } from '../common/MBD/useMBDContext';

import type { StaycationProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/hotels-components/Staycation';

import STYLES from './Staycation.module.scss';

const Staycation = ({ description, sections, title }: StaycationProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();
  const [activeGroupIndex, setActiveGroupIndex] = useState(0);
  const [mobileScrollerRef, setMobileScrollerRef] =
    useState<HTMLElement | null>(null);
  const hasSections = !!sections?.length;

  if (!hasSections) {
    return null;
  }

  const handleOnClickCityPill = (index: number, label: string) => {
    if (mobileScrollerRef?.scroll) {
      mobileScrollerRef?.scroll({ left: 0, behavior: 'smooth' });
    }

    setActiveGroupIndex(index);
  };

  return (
    <div
      className={STYLES.Staycation}
      data-tracking-element-id={rawComponentName}
      data-tracking-common-params={buildMBDParam(rawComponentName)}
    >
      <BpkSectionHeader title={title} description={description} />

      <div className={STYLES.Staycation__cityTabs}>
        <BpkMobileScrollContainer>
          <div className={STYLES.mobile_scroll_container_body}>
            {sections.map(({ label }, index) => (
              <BpkSelectableChip
                key={label}
                className={STYLES.Staycation__cityChip}
                accessibilityLabel={label}
                selected={index === activeGroupIndex}
                onClick={() => handleOnClickCityPill(index, label)}
                data-tracking-element-id={`${rawComponentName}_tab_${index}`}
                data-tracking-common-params={buildMBDParam(
                  `${rawComponentName}_tab`,
                  {
                    tab_name: label,
                  },
                )}
              >
                {label}
              </BpkSelectableChip>
            ))}
          </div>
        </BpkMobileScrollContainer>
      </div>

      <CardRail
        bottomNav
        mobileScrollerRef={(ref) => setMobileScrollerRef(ref)}
      >
        {(layout) =>
          sections[activeGroupIndex].cards.map((card, index) => (
            <InventoryCard
              key={card.title}
              {...card}
              index={`${layout}_${index}`}
            />
          ))
        }
      </CardRail>
    </div>
  );
};

export default Staycation;
